import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/a-propos", "fr", "about");
